// removed by extract-text-webpack-plugin
module.exports = {"message":"src-components-__UserLocationMessage-module___message","fetching":"src-components-__UserLocationMessage-module___fetching src-components-__UserLocationMessage-module___message","pulse":"src-components-__UserLocationMessage-module___pulse","error":"src-components-__UserLocationMessage-module___error src-components-__UserLocationMessage-module___message"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserLocationMessage.module.css
// module id = 1351
// module chunks = 0